import React from 'react';
import Icon from '../../../components/AppIcon';

const CADZoneTypeSelector = ({ selectedType, onTypeChange, disabled, showError }) => {
  const types = [
    {
      id: 'mood',
      label: 'Rendered Plan',
      icon: 'Sparkles',
    },
    {
      id: 'technical',
      label: 'Architectural Plan',
      icon: 'LayoutGrid',
    },
  ];

  return (
    <div className={`glassmorphic-card rounded-3xl p-6 transition-opacity duration-200 ${disabled ? 'opacity-40 pointer-events-none' : ''}`}>
      <div className="flex items-center gap-1 mb-4">
        <span className="text-[12.6px] font-medium text-white">CAD Zone Type</span>
        <span className="text-red-500 text-sm">*</span>
        {showError && !selectedType && (
          <span className="text-red-400 text-[11px] ml-auto">Please select a CAD zone type</span>
        )}
      </div>

      <div className="flex items-center gap-3">
        {types.map((type) => {
          const isActive = selectedType === type.id;
          return (
            <button
              key={type.id}
              onClick={() => onTypeChange(type.id)}
              disabled={disabled}
              className={`flex items-center justify-center gap-2 px-5 py-3 rounded-2xl text-xs font-medium transition-all duration-200 whitespace-nowrap ${
                isActive
                  ? 'bg-orange-500/10 text-orange-400 border border-orange-500/50 shadow-[0_0_15px_rgba(254,131,56,0.15)]'
                  : 'bg-white/5 text-white/50 border border-white/10 hover:border-white/20 hover:text-white/70'
              }`}
            >
              <Icon
                name={type.icon}
                size={14}
                className={isActive ? 'text-orange-400' : 'text-white/40'}
              />
              {type.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CADZoneTypeSelector;
